import resourceMap from '../resources.loc'
import { createReducer } from './reducerUtils'
import { map } from 'rxjs/operators'
import { ofType } from 'redux-observable'

// Actions
export const RESOURCES_LOAD = 'RESOURCE_LOAD'
export const RESOURCES_LOAD_SUCCESS = 'RESOURCE_LOAD_SUCCESS'

// Action creators
export const resourcesLoad = (language) => ({ type: RESOURCES_LOAD, payload: language })
export const resourcesLoadSuccess = (resources) => ({ type: RESOURCES_LOAD_SUCCESS, payload: resources })

// Epics
export const resourcesLoadEpic = (action$, state$) =>
  action$.pipe(
    ofType(RESOURCES_LOAD),
    map(action => resourcesLoadSuccess({
      ...resourceMap['en'],
      ...resourceMap[action.payload]
    }))
  )

// Reducer
const resourcesLoadSuccessReducer = (state, resources) => resources

const resourcesHandlerMapping = {
  [RESOURCES_LOAD_SUCCESS]: resourcesLoadSuccessReducer
}

const resourcesInitialState = resourceMap['en']
export const resourcesReducer = createReducer(resourcesInitialState, resourcesHandlerMapping)

export default resourcesReducer



// WEBPACK FOOTER //
// ./src/store/resources.js